// extracted by mini-css-extract-plugin
export default {"element":"ElementIcon-m_element-e0VY8WPa","d1Badge":"ElementIcon-m_d1Badge-GkomWZL7"};